import React, { useEffect, useState } from 'react'
import { API_BASE_URL } from '../config'
import Navbar from '../components/Navbar'
import { Card, Col, Container, Row, Badge, Spinner } from 'react-bootstrap'
import { TfiWallet } from "react-icons/tfi";
import DataTable from 'react-data-table-component';

const Wallet = () => {

    const [transactions, setTransactions] = useState([]);
    const [balance, setBalance] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const session = JSON.parse(sessionStorage.getItem("user"));


    const fetchWalletHistory = async (page, perPage) => {
        const patientId = session?.payLoad?.user?.Id;
        if (!patientId) return;

        setIsLoading(true);

        try {
            const response = await fetch(
                `${API_BASE_URL}/wallet/history?patientId=${patientId}&page=${page}&perPage=${perPage}`
            );
            const data = await response.json();

            if (data.statusCode === 1) {
                setBalance(data.payLoad.balance);
                setTransactions(data.payLoad.transactions);
                setTotalRows(data.count || 0);
            } else {
                console.warn("Wallet history fetch failed:", data.statusMessage?.[0]);
            }
        } catch (err) {
            console.error("Error fetching wallet history:", err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchWalletHistory(currentPage, perPage);
    }, [currentPage, perPage]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page); // reset to selected page (or 1)
    };


    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#E6E7E8',
                color: '#000',
                fontWeight: 'bold',
            },
        },
        cells: {
            style: {
                backgroundColor: '#ffffff',
                color: '#7F8081',  // ← Updated text color
                fontSize: "12px"
            },
        },
    };

    // Define DataTable columns
    const columns = [
        {
            name: "Date",
            selector: (row) => row.AppointmentDate,
            sortable: true,
        },
        {
            name: "Time",
            selector: (row) => row.AppointmentTime,
        },
        {
            name: "Doctor",
            selector: (row) => row.DoctorName,
        },
        {
            name: "Amount",
            selector: (row) => row.Balance,
            right: true,
        },
        {
            name: "Type",
            selector: (row) => row.Type,
            cell: (row) => (
                <span
                    className={`badge fw-normal ${row.Type === "Credit" ? "usedStatus" : "cancelledStatus"
                        }`}
                >
                    {row.Type}
                </span>
            ),
        },
    ];


    return (
        <>
            <Navbar />
            <Container>
                <Row>
                    <Col md={12}>
                        <Card className='mt-3 shadow-lg border-0'>
                            <div className='bg-white p-2 text-start'>
                                <div className="d-inline-flex wallet_button p-2">
                                    <TfiWallet size={25} />
                                    <span className="ms-1 d-inline-flex">PKR/-&nbsp;{isLoading ? <Spinner size='sm' style={{color:"#FFFFFF"}} /> : balance}</span>
                                </div>
                            </div>
                            <Card.Body className='p-0'>
                                {isLoading ? (
                                    <div className='d-flex justify-content-center align-items-center py-4'>
                                        <Spinner />
                                    </div>
                                ) : (
                                    <DataTable
                                        columns={columns}
                                        data={transactions}
                                        pagination
                                        paginationServer
                                        paginationTotalRows={totalRows}
                                        onChangePage={handlePageChange}
                                        onChangeRowsPerPage={handlePerRowsChange}
                                        responsive
                                        customStyles={customStyles}
                                    />
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Wallet;
